import { FC, useRef } from 'react'
import { createPortal } from 'react-dom'

import Toast from '~/src/components/generic/Toast/components/Toast'
import { ToastListProps } from '~/src/components/generic/Toast/types'
import { toastPositionMap } from '~/src/components/generic/Toast/constants'

import { tw } from '~/lib/utils'

const ToastList: FC<ToastListProps> = ({
  data,
  delay = 30000,
  position = 'top-right',
  showCloseButton = true,
}) => {
  const toastListRef = useRef<HTMLDivElement>(null)

  if (data.length === 0) return null

  const reversedData = [...data].reverse()

  return (
    <>
      {createPortal(
        <div
          aria-live="assertive"
          className={tw(
            'fixed z-[9999] flex w-full max-w-xs flex-col items-center space-y-4 rounded-lg',
            toastPositionMap[position]
          )}
          data-testid="toast-list"
          ref={toastListRef}
        >
          {reversedData.map((toast) => (
            <Toast
              delay={toast.delay ?? delay}
              key={toast.id}
              position={position}
              showCloseButton={toast.showCloseButton ?? showCloseButton}
              style={toast.style}
              toast={toast}
            />
          ))}
        </div>,
        document.body
      )}
    </>
  )
}

export default ToastList
